import { useMatches } from 'react-router'

/** Per-route UI flags, set via `handle` in src/app/router.tsx (PRD §4 navigation notes). */
export interface RouteHandle {
  hideSearchBar?: boolean
  hideBottomNav?: boolean
}

export function useRouteHandle(): RouteHandle {
  const matches = useMatches()
  return Object.assign({}, ...matches.map((m) => (m.handle as RouteHandle | undefined) ?? {}))
}
